import PageHeader from "@/components/PageHeader";
import LegalLayout from "@/components/LegalLayout";
import { useDocumentSEO } from "@/hooks/useDocumentSEO";

export default function GizlilikPage() {
  useDocumentSEO({
    title: "Gizlilik Politikası",
    description:
      "1001 Mimarlık İnşaat ve Ticaret A.Ş. gizlilik politikası. Kullanıcı verilerinin toplanma, kullanım ve koruma esasları hakkında bilgilendirme.",
  });
  return (
    <>
      <PageHeader
        breadcrumb="Gizlilik Politikası"
        overline="Yasal Bilgilendirme"
        title="Gizlilik Politikası"
      />
      <LegalLayout>
        <p>
          1001 Mimarlık İnşaat ve Ticaret A.Ş. olarak, web sitemizi ziyaret
          eden kullanıcıların gizliliğine büyük önem veriyoruz. İşbu Gizlilik
          Politikası; sitemiz üzerinden hangi verileri, hangi amaçla
          topladığımızı ve bu verileri nasıl koruduğumuzu açıklamak amacıyla
          hazırlanmıştır.
        </p>

        <h2>1. Toplanan Veriler</h2>
        <p>
          Web sitemizde yalnızca sizin bize doğrudan iletmeyi tercih ettiğiniz
          veriler toplanmaktadır. Bu kapsamda; iletişim formlarımız
          aracılığıyla ilettiğiniz ad-soyad, telefon, e-posta, kurum/şirket
          bilgisi ve talebinizin içeriği tarafımızca kayıt altına alınır.
          Sitede otomatik olarak profil çıkarma veya bireysel takip amaçlı
          veri toplama yapılmamaktadır.
        </p>

        <h2>2. Verilerin Kullanım Amacı</h2>
        <p>
          Tarafımıza ilettiğiniz veriler yalnızca aşağıdaki amaçlarla
          kullanılır:
        </p>
        <ul>
          <li>Teklif ve iş birliği taleplerinizin değerlendirilmesi,</li>
          <li>Sizinle e-posta veya telefon aracılığıyla iletişime geçilmesi,</li>
          <li>
            İletişim geçmişimizin kurumsal kayıt disiplini çerçevesinde
            saklanması.
          </li>
        </ul>
        <p>
          Verileriniz reklam veya pazarlama amacıyla kullanılmaz; profil
          oluşturma, kredi puanı hesaplama veya benzeri otomatik karar alma
          süreçlerine tabi tutulmaz.
        </p>

        <h2>3. Verilerin Üçüncü Taraflarla Paylaşımı</h2>
        <p>
          Tarafımıza ilettiğiniz kişisel veriler,{" "}
          <strong>hiçbir üçüncü taraf ile ticari amaçla paylaşılmaz</strong>{" "}
          ve satılmaz. Yalnızca aşağıdaki hâllerde ve gerekli ölçüde
          paylaşım yapılabilir:
        </p>
        <ul>
          <li>
            Yasal mevzuat gereği yetkili kamu kurum ve kuruluşlarının resmi
            talebi hâlinde,
          </li>
          <li>
            Hizmet süreçlerimizi yürütmek amacıyla iş birliği yaptığımız,
            gizlilik yükümlülüğü altındaki tedarikçi/iş ortaklarımızla
            sınırlı olarak.
          </li>
        </ul>

        <h2>4. Veri Güvenliği</h2>
        <p>
          Tarafımıza iletilen veriler, endüstri standartlarına uygun teknik
          ve idari tedbirler ile korunmaktadır. Verilerin izinsiz erişim,
          değiştirilme, ifşa veya imha edilmesine karşı gerekli önlemler
          alınmaktadır.
        </p>

        <h2>5. Verilerin Saklanma Süresi</h2>
        <p>
          Kişisel verileriniz; talebinizin gerektirdiği süre boyunca ve
          ilgili mevzuatta öngörülen zorunlu saklama süreleri sonuna kadar
          muhafaza edilir. Saklama süresi sona erdiğinde veriler silinir,
          yok edilir veya anonim hâle getirilir.
        </p>

        <h2>6. Haklarınız</h2>
        <p>
          KVKK&apos;nın 11. maddesi kapsamındaki haklarınızı; kişisel
          verilerinize erişim, düzeltme, silme ve işlenmesine itiraz
          taleplerinizi{" "}
          <a href="mailto:info@1001insaat.com.tr">info@1001insaat.com.tr</a>{" "}
          adresi üzerinden bizimle paylaşabilirsiniz. Konuya ilişkin
          detaylı bilgi için lütfen{" "}
          <a href="/kvkk-aydinlatma-metni">KVKK Aydınlatma Metnimizi</a>{" "}
          inceleyiniz.
        </p>

        <h2>7. Politika Değişiklikleri</h2>
        <p>
          İşbu Gizlilik Politikası zaman zaman güncellenebilir. Güncel metin
          her zaman bu sayfada erişilebilir olacaktır. Önemli değişiklikler
          gerektiğinde ayrıca bilgilendirme yapılabilir.
        </p>

        <p className="legal-note">
          Not: İşbu metin genel bir gizlilik politikası taslağı niteliğinde
          olup, nihai hukuki uygunluk için bir hukuk danışmanı tarafından
          gözden geçirilmesi önerilir.
        </p>
      </LegalLayout>
    </>
  );
}
